import { isEqual } from 'is-equal';
import watch from 'redux-watch';

import {
    submitContactUsForm,
    contactUsData,
    selectContactUsHelpTopic
} from '../actions/helpActions';

import { info } from '../../../core/js/utils/logger';

import { checkForm } from '../../../core/js/utils/errorHandling';

import template from 'contact-us.j2';

import { generate, templateLocationExists } from '../../../core/js/utils/componentUtils';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';

import { scrollToElement } from '../../../core/js/utils/scrollUtils';

/**
 * Attach component events to DOM
 * @param {object} store The redux store
 * @returns {undefined}
 */
export function attachEvents(store) {
    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-contact-us-form'), (e) => {
        e.preventDefault();
        const formData = {
            firstName: $('#contact-first-name').val(),
            lastName: $('#contact-last-name').val(),
            emailAddress: $('#contact-email').val(),
            topic: $('#contact-topic').val(),
            sendToEmail: $('#contact-topic').find(':selected').data('sendToEmail'),
            subjectCode: $('#contact-topic').find(':selected').data('subjectCode'),
            orderNumber: $('#contact-order-number').val(),
            contactMessage: $('#contact-message').val()
        };

        $('#contact-us').trigger('reset');

        // Reset events don't reset textarea or select elements
        $('#contact-message').val('');
        $('#contact-topic').prop('selectedIndex', 0);

        scrollToElement(this.templateLocation);

        store.dispatch(submitContactUsForm(formData));
    });

    $(document).on(this.scopedEvent('change'), this.scopedSelector('#contact-topic'), (e) => {
        const contactTopicIndex = $('#contact-topic option:selected').index() - 1;
        const contactConfigs = _.get(store.getState().core.featureConfigs, 'contact-us-form', []);
        const selectedHelpTopicText = _.get(contactConfigs.topicOptions[contactTopicIndex], 'helpText', "");
        store.dispatch(selectContactUsHelpTopic(selectedHelpTopicText));
    });
}

function attachParsley(component, store) {
    $(component.scopedSelector('.js-contact-us-form')).parsley().on('field:validated', () => {
        const [values, msgs] = checkForm(component.scopedSelector('.js-contact-us-form'));

        let previousMsgs = {};

        if (store.getState().core.modal.forgotPassword) {
            previousMsgs = store.getState().core.modal.forgotPassword.messages;
        }

        store.dispatch(contactUsData(values, msgs, previousMsgs));
    });
}

function afterConstruction(store) {
    attachParsley(this, store);
}

export function attachWatchers(store) {
    let w = watch(store.getState, this.watch, isEqual);

    store.subscribe(w(() => {
        info('Help has updated');
        const dictionary = {
            help: store.getState().help
        };

        this.render(store, this, dictionary);
    }));
}

/**
 * Bootstrap the component onto the page
 * @param {object} store The redux store
 * @param {object} overrides Config for component-level overrides
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-contact-us',
        watch: 'help.contactUsForm',
        name: 'contactUsComponent',
        attachEvents: attachEvents,
        afterConstruction: afterConstruction,
        template: template,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals,
        isComponentValid: templateLocationExists
    };

    return generate(config, store, overrides);
}
